/**
 * Pre-compiled de messages for SearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearInput: `Suchfeld löschen` };
